import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import React from "react";
import Map from "./Map";

const ContactSection = () => {
  // Commented out form-related state
  // const [isLoading, setIsLoading] = useState(false);
  // const form = useRef();
  // const [errors, setErrors] = useState({});
  // const [recaptchaValue, setRecaptchaValue] = useState(null);

  // Commented out form functions
  /*
  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true);

    emailjs
      .sendForm(
        process.env.REACT_APP_API_KEY,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        {
          publicKey: process.env.REACT_APP_PUBLIC_KEY,
        }
      )
      .then(
        () => {
          setIsLoading(false);
          form.current.reset();
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.current.first_name.value) {
      newErrors.first_name = "First Name is required";
    }
    if (!form.current.last_name.value) {
      newErrors.last_name = "Last Name is required";
    }
    if (!form.current.email.value) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(form.current.email.value)) {
      newErrors.email = "Email is invalid";
    }
    if (!form.current.phone.value) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(form.current.phone.value)) {
      newErrors.phone = "Phone number is invalid";
    }
    if (!form.current.company_name.value) {
      newErrors.company_name = "Company Name is required";
    }
    if (!form.current.message.value) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      sendEmail(e);
    }
  };
  */

  return (
    <div
      id="contact"
      className="relative bg-secondary bg-cover bg-center py-16 flex justify-center"
    >
      <div className="relative z-10 container mx-auto flex flex-col items-center px-4 lg:px-0">
        {/* Contact Info Header */}
        <div className="w-full max-w-2xl flex flex-col items-center mb-8">
          <h2 className="text-text-primary text-lg font-semibold text-center">
            Contact Us
          </h2>
          <h3 className="text-primary text-4xl font-bold mt-2 text-center">
            Get in touch
          </h3>

          <div className="mt-6 text-text-primary text-center space-y-4">
            <div>
              <p className="font-medium text-lg mb-2">Contact Info</p>
              <p className="flex items-center justify-center gap-2">
                <EnvelopeIcon className="h-5 w-5" />
                <a href="mailto:info@k-pack.pk" className="hover:text-primary transition-colors">
                  info@k-pack.pk
                </a>
              </p>
              <p className="flex items-center justify-center gap-2 mt-1">
                <PhoneIcon className="h-5 w-5" />
                <a href="tel:+924235297277" className="hover:text-primary transition-colors">
                  +924235297277 <span className="ml-1 text-xs">(landline)</span>
                </a>
              </p>
              <p className="flex items-center justify-center gap-2 mt-1">
                <PhoneIcon className="h-5 w-5" />
                <a href="https://wa.me/923219497991" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  +923219497991 <span className="ml-1 text-xs">(whatsapp)</span>
                </a>
              </p>
            </div>
            
            <div>
              <p className="font-medium">Business Hours:</p>
              <p>Monday - Saturday: 9:00 AM - 5:00 PM</p>
            </div>
          </div>
        </div>

        {/* Map Section - Now centered and full width */}
        <div className="w-full max-w-4xl mx-auto justify-center">
          <Map />
        </div>

        {/* Commented out form section */}
        {/*
        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start">
          <form
            ref={form}
            onSubmit={handleSubmit}
            className="mt-8 px-3 space-y-4 w-full"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="w-full">
                <input
                  minLength={2}
                  maxLength={30}
                  type="text"
                  name="first_name"
                  placeholder="First Name"
                  className="w-full p-3 bg-background-primary text-text-primary rounded-md placeholder-text-secondary focus:outline-none"
                />
                {errors.first_name && (
                  <p className="text-primary text-sm mt-1">
                    {errors.first_name}
                  </p>
                )}
              </div>
              <div className="w-full">
                <input
                  minLength={2}
                  maxLength={30}
                  type="text"
                  name="last_name"
                  placeholder="Last Name"
                  className="w-full p-3 bg-background-primary text-text-primary rounded-md placeholder-text-secondary focus:outline-none"
                />
                {errors.last_name && (
                  <p className="text-primary text-sm mt-1">
                    {errors.last_name}
                  </p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="w-full">
                <input
                  maxLength={50}
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="w-full p-3 bg-background-primary text-text-primary rounded-md placeholder-text-secondary focus:outline-none"
                />
                {errors.email && (
                  <p className="text-primary text-sm mt-1">{errors.email}</p>
                )}
              </div>
              <div className="w-full">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone"
                  className="w-full p-3 bg-background-primary text-text-primary rounded-md placeholder-text-secondary focus:outline-none"
                />
                {errors.phone && (
                  <p className="text-primary text-sm mt-1">{errors.phone}</p>
                )}
              </div>
            </div>

            <div className="w-full">
              <input
                minLength={2}
                maxLength={30}
                type="text"
                name="company_name"
                placeholder="Company Name"
                className="w-full p-3 bg-background-primary text-text-primary rounded-md placeholder-text-secondary focus:outline-none"
              />
              {errors.company_name && (
                <p className="text-primary text-sm mt-1">
                  {errors.company_name}
                </p>
              )}
            </div>

            <div className="w-full">
              <textarea
                minLength={1}
                maxLength={550}
                name="message"
                placeholder="Message"
                rows="4"
                className="w-full p-3 bg-background-primary text-text-primary rounded-md placeholder-text-secondary focus:outline-none"
              ></textarea>
              {errors.message && (
                <p className="text-primary text-sm mt-1">{errors.message}</p>
              )}
            </div>

            <button
              type="submit"
              className="bg-accent text-background-primary py-2 px-4 rounded-md font-semibold hover:bg-accent-dark focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-text-secondary text-sm ml-auto"
            >
              Send Message
            </button>
          </form>
        </div>
        */}
      </div>

      {/* Commented out loader */}
      {/* {isLoading && <Loader />} */}
    </div>
  );
};

export default ContactSection;